/* L'adresse contact@moellia.com renvoie vers la page Contact du site (et non vers la messagerie) */
(function () {
  var TARGET = '/pages/contact';
  var MAIL = 'contact@moellia.com';
  var EMAIL = /contact@moellia\.com/gi;
  var SKIP = /^(A|SCRIPT|STYLE|TEXTAREA|INPUT|SELECT|OPTION|NOSCRIPT|CODE|PRE|TITLE)$/;
  var onContact = /^\/pages\/contact\/?$/.test(location.pathname);

  function link(root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        if (!n.nodeValue || n.nodeValue.toLowerCase().indexOf(MAIL) === -1) return NodeFilter.FILTER_REJECT;
        var p = n.parentElement;
        if (!p || SKIP.test(p.tagName) || p.closest('a')) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(function (node) {
      var text = node.nodeValue;
      var frag = document.createDocumentFragment();
      var last = 0;
      text.replace(EMAIL, function (m, idx) {
        if (idx > last) frag.appendChild(document.createTextNode(text.slice(last, idx)));
        var a = document.createElement('a');
        a.href = TARGET;
        a.textContent = m;
        a.className = 'mo-mailto';
        frag.appendChild(a);
        last = idx + m.length;
        return m;
      });
      if (last < text.length) frag.appendChild(document.createTextNode(text.slice(last)));
      node.parentNode.replaceChild(frag, node);
    });
  }

  /* liens mailto deja presents (pages, politiques, pied de page) : redirigés aussi vers la page Contact */
  function redirect(root) {
    root.querySelectorAll('a[href^="mailto:' + MAIL + '"]').forEach(function (a) {
      a.setAttribute('href', TARGET);
      a.classList.add('mo-mailto');
    });
  }

  function run() {
    if (onContact) return; /* deja sur la page Contact : on garde le lien mail de la carte */
    try { link(document.body); redirect(document.body); } catch (e) {}
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();

  var timer;
  try {
    new MutationObserver(function () { clearTimeout(timer); timer = setTimeout(run, 150); })
      .observe(document.documentElement, { childList: true, subtree: true });
  } catch (e) {}
})();
